import type BaseEnumType from "@/app/services/baseEnumType";
import Key from "@/app/types/common/key";
import { translate, useI18n } from "@/plugins/i18n";

const { $m } = useI18n();

// Probably overkill
export class EnumCommunicationLogLineType implements BaseEnumType {
  private static allValues: EnumCommunicationLogLineType[] = []; // make sure this is top-most

  public static lead = new EnumCommunicationLogLineType(
    0,
    "Lead",
    "leads_noun"
  );
  public static outlet = new EnumCommunicationLogLineType(
    1,
    "Outlet",
    "outlet"
  );
  public static supplierManufacturer = new EnumCommunicationLogLineType(
    2,
    "SupplierManufacturer",
    "supplier"
  );

  public key: number;
  public value: string;
  public translationKey: string;

  private constructor(key: number, value: string, translationKey: string) {
    this.key = key;
    this.value = value;
    this.translationKey = translationKey;
    EnumCommunicationLogLineType.allValues.push(this);
  }

  public get translation() {
    return translate(Key.fromString(this.translationKey));
  }

  public static getValues(): EnumCommunicationLogLineType[] {
    return EnumCommunicationLogLineType.allValues;
  }

  public static getByKey(key: number): EnumCommunicationLogLineType {
    const found = EnumCommunicationLogLineType.allValues.find(
      (e) => e.key === key
    );
    if (found === undefined) {
      throw new Error(`EnumCommunicationLogLineType - Key not found: ${key}`);
    }

    return found;
  }
}
